import { DownloadAltLight } from '@repo/go-icons';
import { Button, Tooltip } from '@repo/go-ui';
import { observer } from 'mobx-react-lite';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { useService } from 'src/packages/di';

import { UserExportTasks } from './UserExportTasks';
import styles from './UserExportTasks.module.scss';

export const UserExportTasksButton = observer(function UserExportTasksButton() {
  const { t } = useTranslation();
  const userFilesService = useService('generatedUserFilesService');

  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (open === true) {
      userFilesService.setHasUpdates(false);
    }
  }, [open, userFilesService]);

  return (
    <Tooltip.Multi
      tooltips={[
        {
          key: 'content',
          trigger: ['click'],
          title: <UserExportTasks onClose={() => setOpen(false)} />,
          delay: 400,
          onOpenChange: setOpen,
          open,
          style: {
            width: 360,
            padding: 0,
          },
          useSafePolygon: false,
        },
        {
          key: 'title',
          trigger: open ? [] : ['hover'],
          title: t('dashboard:UserFiles.title'),
          placement: 'bottom-end',
          useSafePolygon: false,
        },
      ]}
    >
      <div className={styles.userFilesBadge}>
        {userFilesService.hasUpdates && <div className={styles.userFilesBadgeDot} />}
        <Button variant={open ? 'primary' : 'flat'} icon={<DownloadAltLight />} className={styles.userFilesIcon} />
      </div>
    </Tooltip.Multi>
  );
});
